import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    payee: {
        id: '_.your_company.repayment_card.payee',
        defaultMessage: 'Payee'
    },
    accountNumber: {
        id: '_.your_company.repayment_card.account_number',
        defaultMessage: 'Account number'
    },
    sortCode: {
        id: '_.your_company.repayment_card.sort_code',
        defaultMessage: 'Sort code'
    },
    iban: {
        id: '_.your_company.repayment_card.iban',
        defaultMessage: 'IBAN'
    },
    reference: {
        id: '_.your_company.repayment_card.reference',
        defaultMessage: 'Reference'
    },
    repaymentDetails: {
        id: '_.your_company.repayment_card.repayment_details',
        defaultMessage: 'repayment details'
    }
});
